/*
payment/bonusview

create and handle all dom-nodes for the bonus
*/
import core from '../../common/lib/core.js';
import viewBonus from './view-bonus.js';
import viewSpinner from '../../commonview/lib/view-spinner.js';
import viewWrap from '../../commonview/lib/view-wrap.js';
import scrollPosition from '../../../utils/scroll-position.js';
import viewTextkeys from '../../commonview/lib/view-textkeys.js';

const selectors = {
	wrap: null
		/* parse selector from navigation, router.js.
		 template: app/packages/mobile-core-assets/templates/html/deposit/deposit-bonus.mustache
		 */
};
let elements;
let callbackOnConfirm = function callbackOnConfirm() { /* callbackOnConfirm may be passed from router.js to direct the flow to next step on click on submit-button */ };
let viewSpinnerInstance;

function changeNavDepositTitle(text) {
	// TODO; this is a temporary solution in wait for a new created by react components
	// This title belongs to the navigation, which means that each new view (pendingwithdraw,
	// bonus, payment, result) will have it's separate title.
	elements.navdeposittitle = (elements.navdeposittitle || document.querySelector('#js-deposit-header-title'));
	if (elements.navdeposittitle && text) {
		elements.navdeposittitle.innerHTML = text;
	}
}

function deleteAllElements() {
	core.deleteElementsInObjectExcept(elements, ['wrap', 'before', 'textkeys', 'navdeposittitle'], 'bonus/view:23');
}

export default {
	init(wrapSelector = null, confirmCallback = null, inRegistrationFlow = false) {
		selectors.wrap = (wrapSelector || selectors.wrap);
		callbackOnConfirm = (confirmCallback || callbackOnConfirm);
		elements = core.selectElements(selectors, 'deposit/bonus/view:33');
		viewBonus.init({
			wrap: elements.wrap,
			callbackOnConfirm
		});
		viewSpinnerInstance = viewSpinner.create({
			wrap: elements.wrap
		});
		viewWrap.show((elements && elements.wrap));
		const textkeysObj = viewTextkeys.depositflow();
		// TODO: the setting of this title shall probably be set in coordination with
		// react-router and template-system.
		// currently the chain to control is too long:
		// react-router: components, navdeposit.init(config) - where config is fetched
		// from payments/common/utils/router-config which points to an index
		// in mobile-core-assets/templates/html/account/textkeys-payment.mustache
		if(inRegistrationFlow) {
			changeNavDepositTitle(textkeysObj['deposit-bonus-fromregister-title']);
		} else {
			changeNavDepositTitle(textkeysObj['deposit-bonus-title']);
		}
		viewSpinnerInstance.show();
	},
	update(state) {
		/* Data modules send their state with the modulename as property. i.e 'state.foomodule. A 'view_foobar' uses 'state.foomodule'. */
		if (state) {
			if (state.bonuses) {
				viewBonus.update(state);
			}
			if (state.fetch_bonuses) {
				if (state.fetch_bonuses.pending) {
					viewSpinnerInstance.show();
				} else {
					scrollPosition.restore('deposit-bonus', document.querySelector('.js-deposit-bonus'));
					viewSpinnerInstance.hide();
				}
			}
		} else {
			console.warn('deposit/bonus/view: can not update, no state object provided.', state);
		}
	},
	updateFreeMoneyBonusSucces(state) {
		viewBonus.updateFreeMoneyBonusSuccess(state);
	},
	close() {
		deleteAllElements();
		if (viewSpinnerInstance) {
			viewSpinnerInstance.close();
		}
		viewBonus.close();
		viewWrap.hide((elements && elements.wrap));
	}
};



// WEBPACK FOOTER //
// ./mobile-core/src/payment/bonus/lib/view.js